export enum PayformsFilterDateTypes {
  fromDate = 'fromDate',
  toDate = 'toDate',
}
